import React, { useState } from "react";
import { Box, IconButton, Paper, SvgIcon, Typography } from "@mui/material";
import { ARAGON_COLORS } from "../theme/AragonTheme";

function MessageIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M5 5h14v10H9l-4 4V5Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </SvgIcon>
  );
}

export default function SellerMessageBubble({ metrics }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <Paper
          elevation={0}
          sx={{
            position: "fixed",
            right: `${metrics.messageInset}px`,
            bottom: `${metrics.messageInset + metrics.messageBubble + 10}px`,
            width: `${metrics.messagePanelWidth}px`,
            p: `${metrics.cardPadding}px`,
            border: "1px solid rgba(13,25,65,0.12)",
            borderRadius: "10px",
            bgcolor: "#FFFEFC",
            zIndex: 1450,
            boxShadow: "0 14px 34px rgba(13,25,65,0.12)",
          }}
        >
          <Typography sx={{ fontSize: "9px", letterSpacing: "0.14em", textTransform: "uppercase", color: ARAGON_COLORS.burgundy, fontWeight: 700 }}>Messages</Typography>
          <Typography sx={{ mt: "7px", fontFamily: 'Georgia, "Times New Roman", serif', fontSize: "16px", color: ARAGON_COLORS.navy }}>Your advisor</Typography>
          <Typography sx={{ mt: "8px", fontSize: "11px", lineHeight: 1.55, color: ARAGON_COLORS.steel }}>
            Messaging will connect here when the seller communication service is available.
          </Typography>
        </Paper>
      )}
      <Box sx={{ position: "fixed", right: `${metrics.messageInset}px`, bottom: `${metrics.messageInset}px`, zIndex: 1460 }}>
        <IconButton
          aria-label="Messages"
          onClick={() => setOpen((value) => !value)}
          sx={{
            width: `${metrics.messageBubble}px`,
            height: `${metrics.messageBubble}px`,
            bgcolor: ARAGON_COLORS.navy,
            color: "#fff",
            border: "1px solid rgba(224,217,199,0.38)",
            boxShadow: "0 8px 22px rgba(13,25,65,0.20)",
            "&:hover": { bgcolor: "#142455" },
          }}
        >
          <MessageIcon sx={{ fontSize: `${Math.round(metrics.messageBubble * 0.43)}px` }} />
        </IconButton>
        <Box sx={{ position: "absolute", top: "2px", right: "2px", width: "8px", height: "8px", borderRadius: "50%", bgcolor: ARAGON_COLORS.burgundy, border: "1px solid #fff" }} />
      </Box>
    </>
  );
}
